import { AvvirRoutingEvent } from "type_aliases";
import type { BackContext } from "../../models/domain/back_context";

export type ToSupportCenterPageEvent = AvvirRoutingEvent<typeof TO_SUPPORT_CENTER_PAGE, { projectId: string, backContext?: BackContext, featureOfInterest?: string }>

const toSupportCenterPage = (projectId: string, backContext?: BackContext, featureOfInterest?: string): ToSupportCenterPageEvent => ({
  type: TO_SUPPORT_CENTER_PAGE,
  payload: { projectId, backContext, featureOfInterest }
});

export const TO_SUPPORT_CENTER_PAGE = "to_support_center_page";

export default toSupportCenterPage;
